import { tr } from 'i18n';
import { useTranslation as useInterfaceLanguage } from 'react-i18next';
import React from 'react'
import styles from './DocumentView.module.scss'

export default function DocBody({ doc }) {
  useInterfaceLanguage();
  if (doc.main_file_url) {
    return (
      <div className={styles.pdfWrap}>
        <div className={styles.pdfToolbar}>
          <span className={styles.pdfName}>
            📎 {tr(doc.main_file_name || tr("Документ"))}
          </span>
          <a
            className={styles.pdfDownload}
            href={doc.main_file_url}
            target="_blank"
            rel="noreferrer"
          >{tr("⬇ Скачать")}</a>
        </div>
        <iframe
          src={doc.main_file_url}
          className={styles.pdfFrame}
          title={tr("Документ")}
        />
      </div>
    )
  }

  if (doc.content) {
    return (
      <div className={styles.docBodyWrap}>
        <div
          className={styles.docContent}
          dangerouslySetInnerHTML={{ __html: doc.content }}
        />
      </div>
    )
  }

  return (
    <div className={styles.noContent}>
      <span>📭</span>
      <p>{tr("Содержание документа не заполнено")}</p>
    </div>
  )
}
